export default __webpack_public_path__ + "static/tile-overview-dark-11f5835203ba672f2019db26a84be36c.png";